// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"5e7bc133","441":"adc9085c","467":"807ad50b","483":"2db2dc35","682":"a52907b2","896":"4024f42f","920":"b980d1cb"}[chunkId] + ".chunk.js";
};